import * as React from "react";

import { Button, Modal, Icon, Label } from "semantic-ui-react";

import { TimePeriod } from "@teamprevent/common/calendar";

import { Calendar } from "..";

interface Props {
    selectedRoomName?: string;
    highlight: TimePeriod | undefined;
    onRoomSelected: (id: string, name: string) => void;
    onRoomDeselected: () => void;
}

interface State {
    open: boolean;
}

export class RoomSelector extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { open: false };
        this.onRoomSelected = this.onRoomSelected.bind(this);
        this.onRoomDeselected = this.onRoomDeselected.bind(this);
    }

    public render() {
        return (
            <div className="room-selector">
                <Button className="room-selector-button" as="a" content="Select Room" onClick={this.openModal} />
                {this.props.selectedRoomName &&
                    <Label onClick={this.onRoomDeselected}>
                        {this.props.selectedRoomName}
                        <Icon name="delete" />
                    </Label>}
                <Modal open={this.state.open} size="fullscreen">
                    <Modal.Content>
                        <Calendar roomSelector onEntitySelected={this.onRoomSelected} highlight={this.props.highlight} />
                    </Modal.Content>
                    <Modal.Actions>
                        <Button as="a" content="Cancel" onClick={this.closeModal} />
                    </Modal.Actions>
                </Modal>
            </div>
        );
    }

    private onRoomSelected = (id: string, name: string) => {
        this.props.onRoomSelected(id, name);
        this.closeModal();
    };

    private onRoomDeselected = () => {
        this.props.onRoomDeselected();
        this.closeModal();
    };

    private openModal = () => this.setState({ open: true });
    private closeModal = () => this.setState({ open: false });
}
